<header class="shell-header
                group-[&.zenMode]/Shell:-z-10
                group-[&.zenMode]/Shell:shadow-none
                group-[&.zenMode]/Shell:opacity-0
                group-[&.emphazeContent]/Shell:z-10">
  <ShellHeader/>
</header>

@if (hasError()) {
  <section class="size-full grid place-items-center">
    <div class="w-[24rem] aspect-video grid grid-rows-[3rem_1fr_3rem] rounded shadow-4">
      <div class="size-full py-2 px-4 font-medium bg-danger rounded-t inline-flex items-center text-white">
        {{'Http.Error.Default' | translate}}
      </div>
      <div class="size-full py-4 px-4 grid place-items-center">
        {{'Http.Error.Messages.Default' | translate}}
      </div>
      <div class="size-full inline-flex justify-end px-4">
        <button mirButton ghost
            (click)="handleReload()">
          {{'UI.RefreshPage' | translate}}
        </button>
      </div>
    </div>
  </section>
}
@else {
  @if (hasUser()) {
    <section class="shell-navigation
                    group-[&.zenMode]/Shell:-z-20
                    group-[&.zenMode]/Shell:-translate-x-16
                    group-[&.zenMode]/Shell:opacity-0
                    group-[&.emphazeContent]/Shell:z-20"
        [class.expanded]="isNavigationExpanded()">
      <ShellNavigation/>
    </section>

    <section class="shell-router-outlet
                    group-[&.zenMode]/Shell:shadow-[inset_0px_0px_16px_1px_rgba(0,0,0,0.3)]
                    group-[&.zenMode]/Shell:z-90
                    group-[&.zenMode]/Shell:overflow-visible
                    group-[&.emphazeContent]/Shell:z-90">
      <router-outlet></router-outlet>
    </section>

    @if (hasWizardFeature()) {
      @let hasBasket = wizardHasBasket();
      @let panelVisible = isWizardPanelVisible();
      @let panelOpen = panelVisible && isWizardPanelOpened();

      <section class="shell-wizard-section
                      group/WizardSection
                    group-[&.zenMode]/Shell:-z-20
                    group-[&.zenMode]/Shell:translate-x-8
                    group-[&.zenMode]/Shell:opacity-0
                    group-[&.zenMode]/Shell:!w-[0rem]
                    group-[&.zenMode]/Shell:!shadow-none
                    group-[&.emphazeContent]/Shell:z-10"
          [class.has-basket]="hasBasket"
          [class.visible]="panelVisible"
          [class.open]="panelOpen"
          [class.wizardHasBeenUpdated]="wizardHasBeenUpdated()">
        <div class="block size-full z-10 ">

          <div class="absolute z-10 top-0 left-0
                  bg-blue-dark
                  grid
                  grid-cols-[var(--shell-wizard-section-hover-width)_1fr]
                  h-full
                  w-[--shell-wizard-panel-open-width]
                  group-[.open]/WizardSection:delay-0">

            <div class="group/LeftContainer
                    bg-blue-dark
                    size-full
                    z-0
                    grid
                    place-items-center">

              <div class="absolute
                      z-60
                      top-0
                      left-0
                      w-full
                      h-10
                      flex
                      items-center
                      justify-center
                      select-none
                      pointer-events-none
                      transition-all
                      isolate
                          group-[.wizardHasBeenUpdated:not(.open)]/WizardSection:animate-bounce-and-spin-y-1.5
                          group-[.wizardHasBeenUpdated:not(.open)]/WizardSection:repeat-[1]
                          group-[.wizardHasBeenUpdated:not(.open)]/WizardSection:ease-in-out
                          group-[.wizardHasBeenUpdated:not(.open)]/WizardSection:duration-700
                          group-[.wizardHasBeenUpdated:not(.open)]/WizardSection:running">
                <div class="w-max h-full
                        inline-flex
                        items-center
                        gap-x-[1ch]
                        px-4
                        font-medium
                        text-white
                        rotate-[-90deg]
                        translate-y-[calc(200%_-_1rem)]
                        bg-blue-dark
                          group-[.wizardHasBeenUpdated]/WizardSection:rounded-l
                          group-[.wizardHasBeenUpdated]/WizardSection:shadow-1
                        group-[.wizardHasBeenUpdated]/WizardSection:bg-black/5">
                  <span class="truncate">{{'Wizard.Title' | translate}}</span>
                  <MirIcon size="sm" [color]="hasBasket ? 'white' : 'white'">
                    auto_awesome
                  </MirIcon>
                </div>
              </div>


              <div class="group/PanelUI
                      absolute z-90
                      overflow-hidden
                      top-[calc(50%_-_2rem)]
                      w-full
                      h-16
                      inline-flex
                      items-center
                      justify-center
                      text-white
                      bg-white
                      bg-opacity-25
                      hover:bg-primary-hover
                      group-[.open]/WizardSection:bg-primary
                      group-[.open]/WizardSection:hover:bg-primary-hover
                      transition-colors
                      cursor-pointer"
                  (click)="handleToggleExpand()">
                <MirIcon class="transition-all
                            rotate-180
                            opacity-70
                            group-hover/PanelUI:rotate-0
                            group-[.open]/WizardSection:rotate-0
                            group-[.open]/WizardSection:group-hover/PanelUI:rotate-180">
                  chevron_right
                </MirIcon>
              </div>

              <div class="absolute
                            z-50 bottom-0 left-0
                            w-full
                            h-12
                            grid
                            place-items-center
                            text-white
                            opacity-0
                            transition-opacity
                            group-[.has-basket]/WizardSection:opacity-100">
                <MirIcon size="small"
                    mirTooltip
                    [tooltip]="infoIconTooltip()">
                  {{infoIcon()}}
                </MirIcon>
              </div>
            </div>

            <div class="z-0 block size-full overflow-hidden">
              <mir-wizard-panel mode="editing"></mir-wizard-panel>
            </div>
          </div>
        </div>
      </section>
    }

    @if (isSettingsOpened()) {
      <mir-settings></mir-settings>
    }
  } @else {
    <div class="loading-container">
      <LoadingSpinner color="primary" size="normal" bgColor="blue-50">
        {{'UI.Loading' | translate}}
      </LoadingSpinner>
    </div>
  }
}
